// eslint-disable-next-line import/prefer-default-export
export const isByteCookieURL = /^(\/.+|https?:\/\/(?:(?:www\.)?stage\.|www\.)?(bytecookie\.net)?(\/.+))$/i;
export const markdownLinkCustomEvent = /@([\w_-]+):?(.*)/;
